// Placeholder místo grafu, když aktuální role/instance nasazení grafy nesmí vidět.
// Server (/api/chart) v tom případě vrací 401 — tohle je klientská obdoba, aby se
// fetch vůbec nespouštěl. Řízeno canSeeCharts (server, podle role × varianta nasazení
// — viz doc/plans/deploy-variants-a-b-c.md D4), ne jen binárně isAnonymous: varianta B
// grafy ukáže i anonymovi, varianta A je nechává jen pro přihlášené. Zapojeno v
// ChartFrame, ChartImage, ChartView, PeriodChartView, WindRoseInteractive
// (viz doc/plans/registration-and-auth-rework.md D4a).
import { useAuthStore } from '../../../store/useAuthStore'
import { useLoginModalStore } from '../../../store/useLoginModalStore'

export function ChartLoginPlaceholder({ text = 'Grafy jsou dostupné jen přihlášeným uživatelům.' }) {
  const show = useLoginModalStore(s => s.show)
  return (
    <div className="border-2 border-dashed border-gray-300 rounded-xl bg-gray-50
                    flex flex-col items-center justify-center text-center gap-3 p-8 min-h-[280px]">
      <p className="text-gray-600 font-medium">{text}</p>
      <p className="text-sm text-gray-400">Přihlaste se a uvidíte grafy měřených veličin.</p>
      <button
        onClick={show}
        className="px-4 py-2 text-sm rounded-lg bg-blue-600 text-white font-semibold hover:bg-blue-700 transition-colors"
      >
        Přihlásit se
      </button>
    </div>
  )
}

// Hook — vrátí true, pokud se grafy nemají zobrazovat (server pro tuto roli/instanci
// canSeeCharts=false).
export function useChartHidden() {
  return !useAuthStore(s => s.canSeeCharts)
}
